export default __webpack_public_path__ + "static/media/Hokky1.5d756185.gif";